module.exports = __webpack_public_path__ + "static/media/media8.8751f76c.jpeg";